'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReactivationRoute = undefined;

var _requireLoggedIn = require('routes/helpers/requireLoggedIn');

var _requireLoggedIn2 = _interopRequireDefault(_requireLoggedIn);

var _requireMembershipStatus = require('routes/helpers/requireMembershipStatus');

var _requireMembershipStatus2 = _interopRequireDefault(_requireMembershipStatus);

var _path = require('helpers/path');

var _memberStatus = require('enums/memberStatus');

var _Rejoin = require('./Rejoin.saga');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};

/* eslint-disable import/first */

/* eslint-enable */

var ReactivationRoute = exports.ReactivationRoute = function ReactivationRoute(store, client) {
  var requireEligible = function requireEligible(nextState, replaceState, cb) {
    return store.runSagaOnce(_Rejoin.checkWinbackOfferPermissionSaga, client, replaceState, null, '/reactivate/checkout').done.then(cb, cb);
  };

  var redirectToRejoin = function redirectToRejoin(nextState, replaceState, cb) {
    return (0, _path.redirectTo)('/rejoin' + nextState.location.search)(nextState, replaceState, cb);
  };

  return {
    path: 'reactivate',

    onEnter: function onEnter(nextState, replaceState, cb) {
      return store.runSagaOnce(_requireLoggedIn2.default, nextState, replaceState).done.then(function () {
        return store.runSagaOnce(_requireMembershipStatus2.default, client, replaceState, [(0, _memberStatus.memberStatus)('CANCELLED')]).done;
      }).then(cb);
    },
    getComponent: function getComponent(location, callback) {
      require.ensure([], function (require) {
        callback(null, require('./Root').Root);
      }, 'Reactivation');
    },
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function () {
        callback(null, {
          // route deprecated and should use the rejoin pages instead
          onEnter: redirectToRejoin
        });
      }, 'Reactivation');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function (require) {
        callback(null, [{
          path: 'checkout',
          component: require('./FlowContainer').FlowContainer
        }, {
          // 20190102 - Sai - deprecated
          // we no longer support the /reactivate/start route
          // as the full fare checkout page due to hard coding
          // of this route in the mobile apps. Instead, we want
          // this to redirect to the /rejoin route which will
          // always have the current reactivation winback offer.
          // The full fare reactivation checkout page is changed
          // to /reactivate/checkout
          path: 'start',
          onEnter: redirectToRejoin
        }, {
          // only allow
          // - logged in + churned + eligible
          path: 'offer/:promoAlias',
          component: require('./OfferFlowContainer').OfferFlowContainer,
          onEnter: requireEligible
        }, {
          path: 'success',
          component: require('./Success').Success
        }]);
      }, 'Reactivation');
    }
  };
};